// Cents (integer) <-> USD dollar string, for display and input editing only.
export function centsToUsd(cents: number | null | undefined): string {
  if (cents == null || Number.isNaN(cents)) return "";
  return (cents / 100).toFixed(2);
}
// Parse a user-typed dollar string to integer cents. Empty/invalid -> null.
export function usdToCents(text: string): number | null {
  const t = text.trim();
  if (t === "") return null;
  const n = Number(t);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}
